var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDotsBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4 8.30005H4V9.70005H5.4V8.30005Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70005 8.30005H6.30005V9.70005H7.70005V8.30005Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6001 8.30005H10.0001V9.70005H8.6001V8.30005Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H3.4V2H6.30005V0H7.70005V2H10.6001V0H12.0001V2H13C13.0557 2 13.1103 2.00455 13.1636 2.01331C13.2077 2.00458 13.2534 2 13.3001 2C13.6867 2 14.0001 2.3134 14.0001 2.7V13.3C14.0001 13.6866 13.6867 14 13.3001 14L13.2941 14H0.705954L0.7 14C0.313401 14 0 13.6866 0 13.3V2.7C0 2.3134 0.313401 2 0.7 2C0.746709 2 0.792349 2.00457 0.836497 2.0133C0.889701 2.00455 0.944319 2 1 2H2V0ZM12.6001 6H1.4V12.6H12.6001V6Z",
    fill: "#2F80ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDotsBlue);
export default __webpack_public_path__ + "static/media/calendar-dots_blue.600859b3.svg";
export { ForwardRef as ReactComponent };